export function replaceAnswerTextItem(data: any) {
  data.itemTOS = data.itemTOS.map((item) => {
    const modifiedAnswer = item.answerText.replace(
      /<span class="mention target-dad" data-type="mention" data-id="([a-f0-9-]+)" data-label="([^"]+)">@[^<]+<\/span>/g,
      "[resposta-hidden:$1]"
    );

    return {
      ...item,
      answerText: modifiedAnswer,
    };
  });
}

export function restoreAnswerTextItem(content: any) {
  if (content?.length > 0) {
    content = content.map((question) => {
      if (
        !(
          question.type === "DRAG_AND_DROP" ||
          question.type === "FILL_IN_THE_BLANKS"
        )
      )
        return;
      const refactoredQuestion = question;
      const items = question.items?.map((item) => {
        const correctOptions = item?.correctOptions?.map((opt) => {
          return JSON.parse(opt);
        });

        let restoredAnswerText = item.answerText;

        correctOptions.forEach((option) => {
          const regex = new RegExp(`\\[resposta-hidden:${option.id}\\]`, "g");
          restoredAnswerText = restoredAnswerText.replace(
            regex,
            `<span class="mention target-dad" data-type="mention" data-id="${option.id}" data-label="${option.name}">@${option.name}</span>`
          );
        });

        return { ...item, answerText: restoredAnswerText };
      });
      return Object.assign(refactoredQuestion, { items });
    });
  }
}
